import React, { useState } from "react";
import { Modal, Button, Table, Checkbox } from "antd";
import dayjs from "dayjs";
import { useProjectState } from "../../../context/stateContext";
import { getTotalSum } from "./AreasInfoTable";
import "./index.css";

const AreasInfoModal = ({ row }) => {
  const [showPayMethods, setShowPayMethods] = useState(false);
  const { showAreaSalesDetails, setShowAreaSalesDetails } = useProjectState();

  const columns = [
    {
      title: "Дата",
      dataIndex: "date",
      rowKey: "date",
      width: "40%",
      sorter: (a, b) =>
        dayjs(a.date)
          .format("YYYY-MM-DD")
          .localeCompare(dayjs(b.date).format("YYYY-MM-DD")),
      key: "date",
      render: (date) => (
        <span className="waiters-info-table-text">
          {dayjs(date).format("YYYY-MM-DD")}
        </span>
      ),
    },
    {
      title: () => {
        return (
          <div style={{ whiteSpace: "nowrap" }}>
            Общо{" "}
            {getTotalSum(row)
              .toFixed(2)
              .toString()
              .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
              .replace(",", " ")}
          </div>
        );
      },
      dataIndex: "total",
      rowKey: "total",
      width: "15%",
      sorter: (a, b) => a.total - b.total,
      align: "center",
      key: "total",

      render: (total) => (
        <span className="waiters-info-table-text">{total.toFixed(2)}</span>
      ),
    },
  ];

  if (showPayMethods) {
    columns.splice(1, 0, {
      title: "Други",
      dataIndex: "other",
      rowKey: "other",
      width: "15%",
      sorter: (a, b) => a.other - b.other,
      align: "center",
      key: "other",

      render: (other) => (
        <span className="waiters-info-table-text">{other.toFixed(2)}</span>
      ),
    });
    columns.splice(1, 0, {
      title: "Карта",
      dataIndex: "card",
      rowKey: "card",
      width: "15%",
      sorter: (a, b) => a.card - b.card,
      align: "center",
      key: "card",

      render: (card) => (
        <span className="waiters-info-table-text">{card.toFixed(2)}</span>
      ),
    });
    columns.splice(1, 0, {
      title: "Брой",
      dataIndex: "cash",
      rowKey: "cash",
      width: "15%",
      sorter: (a, b) => a.cash - b.cash,
      align: "center",
      key: "cash",

      render: (cash) => (
        <span className="waiters-info-table-text">{cash.toFixed(2)}</span>
      ),
    });
  }

  return (
    <Modal
      className="area-info-modal"
      centered
      width={"650px"}
      cancelButtonProps={{ style: { display: "none" } }}
      open={showAreaSalesDetails}
      bodyStyle={{ height: "auto" }}
      footer={null}
      onCancel={() => setShowAreaSalesDetails(!showAreaSalesDetails)}
    >
      <div className="area-info-header-modal-container">
        <p className="area-info-header-modal-area-name">Обект: {row[0].name}</p>
        <div className="area-info-modal-header-secondary-container">
          <Checkbox
            checked={showPayMethods}
            onChange={() => setShowPayMethods(!showPayMethods)}
            className="areas-checkbox-only-with-value"
          >
            <p className="areas-checkbox-text">Видове Плащания</p>
          </Checkbox>
        </div>
      </div>
      <div className="areas-info-table-container">
        <Table
          rowKey="id"
          dataSource={row}
          columns={columns}
          pagination={false}
          className="areas-info-table"
        />
      </div>

      <div style={{ textAlign: "center", marginTop: "20px" }}>
        <Button
          type="primary"
          onClick={() => setShowAreaSalesDetails(!showAreaSalesDetails)}
        >
          Затвори
        </Button>
      </div>
    </Modal>
  );
};

export default AreasInfoModal;
